import { REWARD_CARD_TYPES, REWARD_TYPES } from '@/utils/constants/rewardsConstants';
import { useQuotaValidation, useLimitPerStoreValidation, useQuotaDigitalCardValidation, useQuotaPhysicalCardValidation, useLimitPerStoreDigitalCardValidation, useLimitPerStorePhysicalCardValidation, useMaxQuantityPerOrderValidation } from '../../validations';

export const useAdditionalAttributesLogic = props => {
  const {formData, handleFormChange, handleValidation} = props

  const {onChange: validateQuota} = useQuotaValidation()
  const {onChange: validateLimitPerStore} = useLimitPerStoreValidation()
  const {onChange: validateMaxQuantityPerOrder} = useMaxQuantityPerOrderValidation()
  const {onChange: validateQuotaDigitalCard} = useQuotaDigitalCardValidation()
  const {onChange: validateQuotaPhysicalCard} = useQuotaPhysicalCardValidation()
  const {onChange: validateLimitPerStoreDigitalCard} = useLimitPerStoreDigitalCardValidation()
  const {onChange: validateLimitPerStorePhysicalCard} = useLimitPerStorePhysicalCardValidation()


  const cleanQuotaFields = isUnlimited => {
    if (isUnlimited) {
      handleFormChange('quota', 'Unlimited')
      handleLeftoverInventoryChange('Unlimited')
      // Clear validation error when unlimited inventory is enabled
      handleValidation('quota', undefined)
    } else {
      handleFormChange('quota', '')
      handleLeftoverInventoryChange('')
    }
  }

  const cleanDigitalAndPhysicalInventoryFields = isUnlimited => {
    if (isUnlimited) {
      handleFormChange('quotaDigitalCard', 'Unlimited')
      handleFormChange('quotaPhysicalCard', 'Unlimited')
      handleLeftoverInventoryDigitalCardChange('Unlimited')
      handleLeftoverInventoryPhysicalCardChange('Unlimited')
      // Clear validation errors when unlimited inventory is enabled
      handleValidation('quotaDigitalCard', undefined)
      handleValidation('quotaPhysicalCard', undefined)
    } else {
      handleFormChange('quotaDigitalCard', '')
      handleFormChange('quotaPhysicalCard', '')
      handleLeftoverInventoryDigitalCardChange('')
      handleLeftoverInventoryPhysicalCardChange('')
    }
  }

  const handleQuotaChange = value => {
    const error = validateQuota(value)
    handleFormChange('quota', value)
    handleValidation('quota', error)
    handleLeftoverInventoryChange(value)
  }

  const handleLeftoverInventoryChange = value => {
    handleFormChange('leftoverInventory', value)
  }

  const handleLimitPerStoreChange = value => {
    const error = validateLimitPerStore(value)
    handleFormChange('limitPerStore', value)
    handleValidation('limitPerStore', error)
  }

  const handleMaxQuantityPerOrderChange = value => {
    const error = validateMaxQuantityPerOrder(value)
    handleFormChange('maxQuantityPerOrder', value)
    handleValidation('maxQuantityPerOrder', error)
  }

  const handleQuotaDigitalCardChange = value => {
    const error = validateQuotaDigitalCard(value)
    handleLeftoverInventoryDigitalCardChange(value)
    handleFormChange('quotaDigitalCard', value)
    handleValidation('quotaDigitalCard', error)
  }

  const handleLeftoverInventoryDigitalCardChange = value => {
    handleFormChange('leftoverInventoryDigitalCard', value)
  }

  const handleLimitPerStoreDigitalCardChange = value => {
    const error = validateLimitPerStoreDigitalCard(value)
    handleValidation('limitPerStoreDigitalCard', error)
    handleFormChange('limitPerStoreDigitalCard', value)
  }

  const handleQuotaPhysicalCardChange = value => {
    const error = validateQuotaPhysicalCard(value)
    handleLeftoverInventoryPhysicalCardChange(value)
    handleFormChange('quotaPhysicalCard', value)
    handleValidation('quotaPhysicalCard', error)
  }

  const handleLeftoverInventoryPhysicalCardChange = value => {
    handleFormChange('leftoverInventoryPhysicalCard', value)
  }

  const handleLimitPerStorePhysicalCardChange = value => {
    const error = validateLimitPerStorePhysicalCard(value)
    handleValidation('limitPerStorePhysicalCard', error)
    handleFormChange('limitPerStorePhysicalCard', value)
  }

  // Handlers for ToggleRow
  const handleDisplayOutOfStockChange = value => {
    handleFormChange('displayOutOfStock', value)
  }

  const handleUnlimitedInventoryChange = value => {
    if (formData?.rewardCardType === REWARD_CARD_TYPES.Both && formData?.rewardType === REWARD_TYPES.VISA_CARD) {
      cleanDigitalAndPhysicalInventoryFields(value)
    } else {
      cleanQuotaFields(value)
    }
    handleFormChange('unlimitedInventory', value)
  }

  const handleInStockChange = value => {
    handleFormChange('inStock', value)
  }

  return {
    handleQuotaChange,
    handleLeftoverInventoryChange,
    handleLimitPerStoreChange,
    handleMaxQuantityPerOrderChange,
    handleQuotaDigitalCardChange,
    handleLeftoverInventoryDigitalCardChange,
    handleLimitPerStoreDigitalCardChange,
    handleQuotaPhysicalCardChange,
    handleLeftoverInventoryPhysicalCardChange,
    handleLimitPerStorePhysicalCardChange,
    handleDisplayOutOfStockChange,
    handleUnlimitedInventoryChange,
    handleInStockChange,
  }
}
